export default __webpack_public_path__ + "static/media/subSection-picture.0b3997f4.jpg";